import { LLM_CHAT_ATTACHMENT_ACCEPTED_MIME_TYPES } from '@paladin-monorepo/common';

export const LLM_CHAT_ATTACHMENT_ACCEPT = [
  ...LLM_CHAT_ATTACHMENT_ACCEPTED_MIME_TYPES,
  '.numbers',
  '.pages',
  '.pptx',
].join(',');

export function getAttachmentFileIcon(
  name: string,
): 'sheet' | 'doc' | 'slides' | 'csv' | 'numbers' | 'pages' | 'file' {
  const lower = name.toLowerCase();
  if (lower.endsWith('.numbers')) {
    return 'numbers';
  }
  if (lower.endsWith('.pages')) {
    return 'pages';
  }
  if (lower.endsWith('.xlsx') || lower.endsWith('.xls') || lower.endsWith('.xlsm')) {
    return 'sheet';
  }
  if (lower.endsWith('.pptx')) {
    return 'slides';
  }
  if (lower.endsWith('.docx') || lower.endsWith('.doc')) {
    return 'doc';
  }
  if (lower.endsWith('.csv') || lower.endsWith('.tsv')) {
    return 'csv';
  }
  return 'file';
}
